<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
    >
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="fa fa-envelope-o"></i>
        </span>
        <h3 class="kt-portlet__head-title">Secret Shop Summary Logs</h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-card class="kt-widget29" data-app>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="fal fa-search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a
                href="javascript:"
                class="btn btn-default m-btn m-btn--icon btn-lg m-btn--icon-only ml-2"
                v-on="on"
                id="popover-option-button"
                @click="togglePopover"
              >
                <i class="fa fa-sliders-v" />
              </a>
            </template>
            <span>Options</span>
          </v-tooltip>
        </v-card-title>
        <v-simple-table>
          <thead>
            <tr>
              <th class="text-left">Name</th>
              <th class="text-left">Email</th>
              <th class="text-left">Filename</th>
              <th class="text-left">Created at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="exportLog in filtersearch" :key="exportLog.id">
              <td>{{ exportLog.name }}</td>
              <td>{{ exportLog.email }}</td>
              <td>
                <a :href="exportLog.download_file" target="_blank">{{
                  exportLog.file_name
                }}</a>
              </td>
              <td>{{ formatDate(exportLog.created_at) }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <b-popover
          target="popover-option-button"
          triggers="click"
          :show.sync="popoverOption"
          placement="auto"
          container="my-container"
          ref="popover"
        >
          <template v-slot:title> Options </template>
          <v-row>
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  label="Date From:"
                  prepend-icon="fal fa-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateFrom"
                color="primary"
                no-title
                @input="menu = false"
              >
              </v-date-picker>
            </v-menu>
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-width="200"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  label="Date to:"
                  prepend-icon="fal fa-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateTo"
                color="primary"
                no-title
                @input="menu2 = false"
              >
              </v-date-picker>
            </v-menu>
          </v-row>
          <v-btn
            color="primary"
            dark
            class="mb-2 mt-2 mt-sm-0 mx-auto"
            :loading="loader"
            :disabled="loader"
            @click="Datefilter"
          >
            Submit
          </v-btn>
        </b-popover>
      </v-card>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      menu: false,
      menu2: false,
      popoverOption: false,
      search: '',
      exportLogs: [],
      dateFilter: [],
    };
  },
  computed: {
    filtersearch() {
      return this.exportLogs.filter((exportLog) => {
        return exportLog.name.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  methods: {
    exportLog() {
      this.axios
        .get('secret-shops-summary-log')
        .then(({ data }) => (this.exportLogs = data))
        .catch();
    },
    Datefilter() {
      this.axios
        .get('export-log-date-filter', {
          params: { dateFrom: this.dateFrom, dateTo: this.dateTo },
        })
        .then(({ data }) => (this.exportLogs = data))
        .catch();
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('MMM D, YYYY, h:mm');
    },
    togglePopover() {
      this.popoverOption = !this.popoverOption;
    },
  },

  created() {
    this.exportLog();
  },
};
</script>
<style lang="stylus" scoped>
.kt-widget29__title
  font-family Oswald

.heading-result
  color #333

.kt-portlet.kt-portlet--solid-dark
  background #333 !important

.vdp-datepicker__clear-button
  position: absolute
  top: 13px
  right: 10px
</style>
